export default function StoryblokSuggestionResultHeader({ description }: { description: string }) {
  return (
    <div className="flex h-14 bg-gray-100 px-2.5 text-lg font-bold hover:bg-[#19466d] hover:text-white">
      <span className="my-auto">{description}</span>
    </div>
  )
}
